const contactItems = [
  {
    group: "Location",
    items: [
      { label: "Address", value: "SRPSKIH VLADARA 447", icon: "ri-map-pin-2-line" },
      { label: "City", value: "Pirot", icon: "ri-community-line" },
      { label: "Zip", value: "620220", icon: "ri-mail-open-line" },
      { label: "Country", value: "Serbia", icon: "ri-global-line" },
    ],
  },
  {
    group: "Get in Touch",
    items: [
      { label: "Email", value: "info@roxtveldoopirot.com", icon: "ri-mail-line" },
      { label: "Number", value: "+1 3613044887", icon: "ri-phone-line" },
    ],
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="w-full" style={{ background: "#1A3A2E" }}>
      {/* Upper content */}
      <div className="max-w-7xl mx-auto px-10 pt-20 pb-16">
        {/* Label */}
        <p className="text-xs uppercase tracking-widest font-medium mb-6" style={{ color: "#B8D4C8" }}>
          &bull;&nbsp; Contact Us
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
          {/* Left: company intro */}
          <div className="lg:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/4d56948f-f323-4cfa-8fd6-32510aea7808.png"
              alt="ROXTVEL d.o.o. Pirot"
              className="h-12 w-auto object-contain mb-5"
              style={{ filter: "brightness(0) invert(1)" }}
            />
            <h2 className="text-2xl font-bold mb-3" style={{ color: "#E8DCC4", fontFamily: "'Inter', sans-serif" }}>
              ROXTVEL d.o.o. Pirot
            </h2>
            <p className="text-sm leading-relaxed" style={{ color: "#7A9E90" }}>
              Expert team developing modern iOS applications focused on user security and device performance. Based in Pirot, Serbia.
            </p>
          </div>

          {/* Right: contact info groups */}
          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-10">
            {contactItems.map((group) => (
              <div key={group.group}>
                <p
                  className="text-xs uppercase tracking-widest font-medium mb-5"
                  style={{ color: "#7A9E90" }}
                >
                  {group.group}
                </p>
                <ul className="flex flex-col gap-4">
                  {group.items.map((item) => (
                    <li key={item.label} className="flex items-start gap-3">
                      <div
                        className="w-7 h-7 flex items-center justify-center rounded-md flex-shrink-0 mt-0.5"
                        style={{ background: "rgba(255,255,255,0.08)" }}
                      >
                        <i className={`${item.icon} text-sm`} style={{ color: "#B8D4C8" }} />
                      </div>
                      <div>
                        <span className="block text-xs font-medium uppercase tracking-wide mb-0.5" style={{ color: "#7A9E90" }}>
                          {item.label}
                        </span>
                        <span className="text-sm font-medium" style={{ color: "#FFFFFF" }}>
                          {item.value}
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="max-w-7xl mx-auto px-10">
        <div className="w-full h-px" style={{ background: "rgba(255,255,255,0.08)" }} />
      </div>

      {/* Big brand name */}
      <div className="w-full px-10 py-10 overflow-hidden">
        <p
          className="font-extrabold leading-none select-none tracking-tight"
          style={{
            fontSize: "clamp(60px, 10vw, 140px)",
            color: "rgba(255,255,255,0.06)",
            fontFamily: "'Inter', sans-serif",
            letterSpacing: "-0.02em",
          }}
        >
          ROXTVEL
        </p>
      </div>

      {/* Bottom strip */}
      <div
        className="w-full px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs"
        style={{ color: "#4A7A6A", borderTop: "1px solid rgba(255,255,255,0.05)" }}
      >
        <span>&copy; {new Date().getFullYear()} ROXTVEL d.o.o. Pirot. All rights reserved.</span>
        <span>iOS App Development &mdash; Pirot, Serbia</span>
      </div>
    </section>
  );
}
